<div class="">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-12 lg:mx-24 mt-6 md:mt-16 mb-20">

        @for(item of items; track $index){
        <a class="block bg-white rounded-lg p-4 mx-auto  max-w-[333px] md:mt-4
       border border-black/5
       shadow-md">

            <div class=" relative flex justify-center items-center rounded-lg overflow-hidden">
                <div class="flex justify-center w-[324px] h-[221px]  cursor-pointer">

                    @if(item?.imageUrl)
                    {
                    <img loading="lazy" [src]="absoluteMediaUriService.getAbsoluteMediaUri(item?.imageUrl)"
                        [routerLink]="['/item-detals-bc', 'item', item.id]" class="w-full h-full  object-cover ">

                    }@else{
                    <img loading="lazy" [src]="'notImage.jpg'" class="w-full h-full  object-fill rounded-lg ">
                    }

                </div>

                <button type="button"
                    (click)="toggleFavorite(item.id, item.isFavorite); $event.preventDefault(); $event.stopPropagation();"
                    aria-label="Toggle favorite" class="absolute top-0 right-0 z-10
         grid place-items-center
         w-8 h-8 rounded-full
         bg-white/80 backdrop-blur-sm
         border border-black/10
         shadow-md
         transition hover:scale-105 hover:bg-white">
                    <fa-icon [icon]="item.isFavorite ? faBookmarkSolid : faBookmarkRegular" class="text-[var(--sky-blue)]
              cursor-pointer"></fa-icon>
                </button>
            </div>

            <div class=" w-[98%] mx-aut  ml-2 mt-1">
                <h3 class="text-[var(--dark-teal)]  font-noto-serif text-xl font-bold cursor-pointer m-0 hover:underline mt-6  mb-2"
                    [innerHTML]="item.name | sanitizeHtmlText" [routerLink]="['/item-detals-bc', 'item', item.id]">

                </h3>
                <div class="text-gray-700 ">
                    <span class="text-[20px] font-semibold text-custom-black ">{{
                        (item?.currentLeadingBid ?? item?.buyNowPrice) | currency:'USD':'symbol':'1.2-2' }}
                    </span>

                    <span class="text-[var(--sky-blue)]  font-semibold ml-2">
                        {{
                        item?.currentLeadingBid! > 0
                        ? (item?.numberOfBids! > 0 ? 'Leading Bid' : 'Opening Bid')
                        : (item?.buyNowPrice! > 0 && item?.numberOfBids! === 0 ? 'Buy Now' : 'Leading Bid')
                        }}
                    </span>
                </div>
                <h3 class="text-custom-gray-dark  cursor-pointer m-0 hover:underline break-words whitespace-normal mt-3"
                    [innerHTML]="item.orgName | sanitizeHtmlText" [routerLink]="['/auction', item.auctionId]">

                </h3>

                <div class="mt-4">

                    <button pButton
                        class="mt-6 lg:mt-2  h-[35px]  w-full  rounded-md flex items-center justify-center "
                        [routerLink]="['/item-detals-bc', 'item', item.id]">
                        <span class=" !text-[var(--p-text-color-secondary)] text-center w-ful font-noto-serif">
                            @if (item.currentLeadingBid > 0) {
                            <span>Place a Bid</span>
                            } @else if (item.buyNowPrice) {
                            <span>Buy Now</span>
                            } @else {
                            <span>See More</span>
                            }
                        </span>
                    </button>
                </div>
            </div>

            <p class=" text-center text-[var(--charcoal)]  font-medium italic text-sm "> {{
                timeLeftService.getTimeLeft(item.auctionOpeningDate, item.auctionClosingDate) }}
            </p>
        </a>
        }

    </div>
</div>